import { apiBusSchedBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

export class ComponentAPI {
    constructor() {
        this.baseUrl = new URL("bussched/components/", apiBusSchedBaseURL);
    }

    listFontTargets(componentType) {
        return API.authenticatedRequest({
            url: new URL(`targets/font/${componentType}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    listBackgroundTargets(componentType) {
        return API.authenticatedRequest({
            url: new URL(`targets/background/${componentType}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    listMarginTargets(componentType) {
        return API.authenticatedRequest({
            url: new URL(`targets/margin/${componentType}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    listCircleElementTargets(componentType) {
        return API.authenticatedRequest({
            url: new URL(`targets/circleelement/${componentType}`, this.baseUrl),
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/bussched/ComponentAPI.js